import React from 'react';
import FacilityRow from './types/facility-row';
import RegionRow from './types/region-row';
import BooleanRow from './types/boolean-row';
import GenderRow from './types/gender-row';
import DateRow from './types/date-row';
import DateOfBirthRow from './types/date-of-birth-row';
import DefaultRow from './types/default-row';
import TimesPlayedRow from './types/times-played-row';

const SimpleFilter = ({filter, i, allColumns, updateColumn, regionsAndLocations, updateType, updateCondition,
                         updateValue, updateDateConditionChild, updateNumberCondition, onDeleteFilter}) => {

  var index = i.slice(-1)
  return <tr>
    <td>
      <div className='col-sm-1 text-left table-parent zero-padding-x'>
        {index != 0 ? <select name='root-condition' value={filter.type} onChange={e=> updateType(e.target.value, i)}>
          { ['and','or'].map((o, i) => <option key={i} value={o}>{o}</option>) }
        </select> : <span>Where</span>}
      </div>
      <div className='col-sm-11 text-left zero-padding-x'>
        <select name='filter-type' value={filter.column} onChange={e=> updateColumn(e.target.value, i)}>
        { Object.keys(allColumns).map((o, i) => <option key={i} value={o}>{allColumns[o].title}</option>) }
        </select>&nbsp;
        { 'region' == filter.column &&
          <RegionRow
            filter={filter}
            conditionsList={allColumns[filter.column].conditions}
            regions={regionsAndLocations[filter.column]}
            updateCondition={(e)=>updateCondition(e,i)}
            updateValue={(e)=>updateValue(e,i)}
          />}
        { 'facility' == filter.column &&
          <FacilityRow
            filter={filter}
            conditionsList={allColumns[filter.column].conditions}
            locations={regionsAndLocations[filter.column]}
            updateCondition={(e)=>updateCondition(e,i)}
            updateValue={(e)=>updateValue(e,i)}
          />}
        { ['opted_out','captain','free_games','banned','devices_banned','hide_fake_players','hide_facility_players'].includes(filter.column) &&
          <BooleanRow
            filter={filter}
            updateValue={(e)=>updateValue(e,i)}
          />}
        { 'gender' == filter.column &&
          <GenderRow
            filter={filter}
            conditionsList={allColumns[filter.column].conditions}
            updateCondition={(e)=>updateCondition(e,i)}
            updateValue={(e)=>updateValue(e,i)}
          />}
        { ['dates_joined','dates_played','cancelled_games'].includes(filter.column) &&
          <DateRow
            filter={filter}
            conditionsList={allColumns[filter.column].conditions}
            updateCondition={(e)=>updateCondition(e,i)}
            updateDateConditionChild={(e)=>updateDateConditionChild(e,i)}
            updateValue={(e)=>updateValue(e,i)}
          />}
        { ['date_of_birth'].includes(filter.column) &&
          <DateOfBirthRow
            filter={filter}
            conditionsList={allColumns[filter.column].conditions}
            updateCondition={(e)=>updateCondition(e,i)}
            updateDateConditionChild={(e)=>updateDateConditionChild(e,i)}
            updateValue={(e)=>updateValue(e,i)}
          />}
        { ['name','phone','email','info'].includes(filter.column) &&
          <DefaultRow
            filter={filter}
            conditionsList={allColumns[filter.column].conditions}
            updateCondition={(e)=>updateCondition(e,i)}
            updateValue={(e)=>updateValue(e,i)}
          />}
        { 'times_played' == filter.column &&
          <TimesPlayedRow
            filter={filter}
            conditionsList={allColumns[filter.column].conditions}
            updateNumberCondition={(e)=>updateNumberCondition(e,i)}
            updateValue={(e)=>updateValue(e,i)}
          />}&nbsp;
        <span
          className='fa fa-trash'
          onClick={() => onDeleteFilter(i)}>
        </span>
      </div>
    </td>
  </tr>
}

export default SimpleFilter
